module.exports = __webpack_public_path__ + "img/build.12e5219e.svg";